import { setupFPlusLanguage } from '@festina-life/fplus'
import { useEffect, useRef, useState } from 'react'

export const useSetupFPlusViewer = () => {
  const [didSetupThemes, setDidSetupThemes] = useState(false)
  const ref = useRef(false)
  useEffect(() => {
    if (!didSetupThemes && !ref.current) {
      ref.current = true
      void setupFPlusLanguage().then(() => setDidSetupThemes(true))
    }
  }, [didSetupThemes, ref])

  return { isReady: didSetupThemes }
}
